import { Box, Card, CardActionArea, CardContent, Typography, useTheme } from "@mui/material";

import { TeamGoalConfigurationFragment, TeamPageTeamFragment } from "../../../../types";
import DashboardCard from "../Card";
import DownloadButton from "./DownloadButton";
import TeamGoalsSummaryEmptyContent from "./TeamGoalsSummaryEmptyContent";

interface TeamGoalsSummaryProps {
  teamGoalConfigurations?: readonly TeamGoalConfigurationFragment[];
  team: TeamPageTeamFragment;
}

const TeamGoalsSummary = ({ teamGoalConfigurations = [], team }: TeamGoalsSummaryProps) => {
  const { spacing } = useTheme();

  const uniqueAthleteCount = new Set(teamGoalConfigurations.map(goal => goal.athlete?.id)).size;

  return (
    <DashboardCard title="Goals" options={<DownloadButton data={teamGoalConfigurations} teamName={team.name} />}>
      <Box sx={{ width: "100%", height: "100%" }}>
        {teamGoalConfigurations.length > 0 ? (
          <Card>
            <CardActionArea>
              <CardContent sx={{ width: "100%", p: spacing(2) }} tabIndex={0}>
                <Typography variant="body2">
                  {uniqueAthleteCount}/{team.athletes.length} athletes on the team have goals
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ) : (
          <TeamGoalsSummaryEmptyContent />
        )}
      </Box>
      <div />
    </DashboardCard>
  );
};

export default TeamGoalsSummary;
